import { Pipe, PipeTransform } from '@angular/core';
import { responseLevelText } from '../utils'

@Pipe({
  name: 'reponseLevelText'
})
export class ReponseLevelTextPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    return responseLevelText(value);
  }

}
